// Utility functions for parcel/qPublic links

// qPublic tax assessor URLs by county (lowercase keys)
// These link to the county's search page - user can then search by address
const QPUBLIC_URLS = {
  hall: 'https://qpublic.schneidercorp.com/Application.aspx?App=HallCountyGA&Layer=Parcels&PageType=Search',
  forsyth: 'https://qpublic.schneidercorp.com/Application.aspx?App=ForsythCountyGA&Layer=Parcels&PageType=Search',
  cherokee: 'https://qpublic.schneidercorp.com/Application.aspx?App=CherokeeCountyGA&Layer=Parcels&PageType=Search',
  dawson: 'https://qpublic.schneidercorp.com/Application.aspx?App=DawsonCountyGA&Layer=Parcels&PageType=Search',
  lumpkin: 'https://qpublic.schneidercorp.com/Application.aspx?App=LumpkinCountyGA&Layer=Parcels&PageType=Search',
  white: 'https://qpublic.schneidercorp.com/Application.aspx?App=WhiteCountyGA&Layer=Parcels&PageType=Search',
  habersham: 'https://qpublic.schneidercorp.com/Application.aspx?App=HabershamCountyGA&Layer=Parcels&PageType=Search',
  rabun: 'https://qpublic.schneidercorp.com/Application.aspx?App=RabunCountyGA&Layer=Parcels&PageType=Search',
  towns: 'https://qpublic.schneidercorp.com/Application.aspx?App=TownsCountyGA&Layer=Parcels&PageType=Search',
  union: 'https://qpublic.schneidercorp.com/Application.aspx?App=UnionCountyGA&Layer=Parcels&PageType=Search',
  fannin: 'https://qpublic.schneidercorp.com/Application.aspx?App=FanninCountyGA&Layer=Parcels&PageType=Search',
  gilmer: 'https://qpublic.schneidercorp.com/Application.aspx?App=GilmerCountyGA&Layer=Parcels&PageType=Search',
  pickens: 'https://qpublic.schneidercorp.com/Application.aspx?App=PickensCountyGA&Layer=Parcels&PageType=Search',
  murray: 'https://qpublic.schneidercorp.com/Application.aspx?App=MurrayCountyGA&Layer=Parcels&PageType=Search',
  whitfield: 'https://qpublic.schneidercorp.com/Application.aspx?App=WhitfieldCountyGA&Layer=Parcels&PageType=Search',
  gordon: 'https://qpublic.schneidercorp.com/Application.aspx?App=GordonCountyGA&Layer=Parcels&PageType=Search',
  bartow: 'https://qpublic.schneidercorp.com/Application.aspx?App=BartowCountyGA&Layer=Parcels&PageType=Search',
  floyd: 'https://qpublic.schneidercorp.com/Application.aspx?App=FloydCountyGA&Layer=Parcels&PageType=Search',
  polk: 'https://qpublic.schneidercorp.com/Application.aspx?App=PolkCountyGA&Layer=Parcels&PageType=Search',
  paulding: 'https://qpublic.schneidercorp.com/Application.aspx?App=PauldingCountyGA&Layer=Parcels&PageType=Search',
  cobb: 'https://qpublic.schneidercorp.com/Application.aspx?App=CobbCountyGA&Layer=Parcels&PageType=Search',
  gwinnett: 'https://qpublic.schneidercorp.com/Application.aspx?App=GwinnettCountyGA&Layer=Parcels&PageType=Search',
  jackson: 'https://qpublic.schneidercorp.com/Application.aspx?App=JacksonCountyGA&Layer=Parcels&PageType=Search',
  banks: 'https://qpublic.schneidercorp.com/Application.aspx?App=BanksCountyGA&Layer=Parcels&PageType=Search',
  franklin: 'https://qpublic.schneidercorp.com/Application.aspx?App=FranklinCountyGA&Layer=Parcels&PageType=Search',
  stephens: 'https://qpublic.schneidercorp.com/Application.aspx?App=StephensCountyGA&Layer=Parcels&PageType=Search',
  hart: 'https://qpublic.schneidercorp.com/Application.aspx?App=HartCountyGA&Layer=Parcels&PageType=Search',
  madison: 'https://qpublic.schneidercorp.com/Application.aspx?App=MadisonCountyGA&Layer=Parcels&PageType=Search',
  elbert: 'https://qpublic.schneidercorp.com/Application.aspx?App=ElbertCountyGA&Layer=Parcels&PageType=Search',
  barrow: 'https://qpublic.schneidercorp.com/Application.aspx?App=BarrowCountyGA&Layer=Parcels&PageType=Search',
  walton: 'https://qpublic.schneidercorp.com/Application.aspx?App=WaltonCountyGA&Layer=Parcels&PageType=Search',
  oconee: 'https://qpublic.schneidercorp.com/Application.aspx?App=OconeeCountyGA&Layer=Parcels&PageType=Search',
  clarke: 'https://qpublic.schneidercorp.com/Application.aspx?App=ClarkeCountyGA&Layer=Parcels&PageType=Search',
  walker: 'https://qpublic.schneidercorp.com/Application.aspx?App=WalkerCountyGA&Layer=Parcels&PageType=Search',
  catoosa: 'https://qpublic.schneidercorp.com/Application.aspx?App=CatoosaCountyGA&Layer=Parcels&PageType=Search',
  chattooga: 'https://qpublic.schneidercorp.com/Application.aspx?App=ChattoogaCountyGA&Layer=Parcels&PageType=Search',
  dade: 'https://qpublic.schneidercorp.com/Application.aspx?App=DadeCountyGA&Layer=Parcels&PageType=Search'
};

/**
 * Normalize county name to lowercase key
 * Handles variations like "Gordon County", "Gordon", "gordon county", etc.
 */
export function normalizeCounty(county) {
  if (!county) return null;
  return county
    .toLowerCase()
    .replace(' county', '')
    .replace('county', '')
    .trim();
}

/**
 * Build qPublic URL for a given county and optional address
 * @param {string} county - County name (e.g., "Gordon", "Gordon County")
 * @param {string} address - Optional property address to search
 * @returns {string|null} - qPublic URL or null if county not found
 */
export function buildQPublicUrl(county) {
  const normalizedCounty = normalizeCounty(county);
  if (!normalizedCounty) return null;

  const baseUrl = QPUBLIC_URLS[normalizedCounty];
  if (!baseUrl) return null;

  // Return base URL - user will search manually on qPublic site
  return baseUrl;
}

/**
 * Check if a county has a qPublic URL configured
 */
export function hasQPublicUrl(county) {
  const normalizedCounty = normalizeCounty(county);
  return normalizedCounty && QPUBLIC_URLS[normalizedCounty];
}

/**
 * Get all available county names
 */
export function getAvailableCounties() {
  return Object.keys(QPUBLIC_URLS).map(key =>
    key.charAt(0).toUpperCase() + key.slice(1) + ' County'
  );
}

export default QPUBLIC_URLS;
